import React from 'react';

import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ClearVerifyLogo, Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { FormContent, SuccessContent } from './components';

export const UserChangePasswordModal: React.FC = () => {
  const navigate = useNavigate();

  const { closeModal, isOpen, switchClosability } = useModal(ModalId.UserChangePasswordModal);

  const [submitted, setSubmitted] = React.useState(false);

  const onCloseModal = React.useCallback(() => {
    closeModal();
    if (submitted) {
      navigate(appRoutes.auth.logout);
    } else {
      navigate(appRoutes.root);
    }
  }, [closeModal, submitted, navigate]);

  const onSubmitCallback = React.useCallback(() => {
    setSubmitted(true);
    setTimeout(() => {
      navigate(appRoutes.auth.logout);
    }, 5000);
  }, [navigate]);

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={600}
    >
      <Grid container>
        <Grid mt={-2} size={12}>
          <ClearVerifyLogo />
        </Grid>
        {!submitted ? (
          <FormContent onSubmitCallback={onSubmitCallback} switchClosability={switchClosability} />
        ) : (
          <SuccessContent onCloseModal={onCloseModal} />
        )}
      </Grid>
    </Modal>
  );
};
